

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface LabResultParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}
export const labStatus = {
  OPEN: 'Open',
  INPROGRESS: 'In-Progress',
  COMPLETED: 'Completed'
};

export interface LabResult {
    labResultId:string,
    id?: string;
    labResultValue?:string,
    labNormalValue?:string,
    labUnit?:string,
    serviceId:string,
    externalLab?:string
    //Barcode added for Lab Automation -Abirami - 08-02
    barcode?:string,
	  Comments?: string,
    OldTime?:Date,
    OldUser?: string,
    NewLabResultValue?:string, 
    NewTime?:Date,
    NewUser ?:string,
    parameters?: LabResultParameter[];
    links?: any;
    workOrderRegisterId?:number;
    labTestId?: string;
    
    isCultureTest?:boolean;
    CultureJson?: string;
    HistopathologyJson?: string;
    isHistopathologyTest?:boolean;
    isCytologyTest?:boolean;
    CytologyJson?: string;
    cutoffValue?:string;
}
export interface labDelayReasonDet{
  labDelayReasonId: string;
  WOId :number;
  LabResultMstId: string;
  LabResultDetId: string;
  ServiceId: string;
  delayReasonNotes: string;
  tenantId:string; 
  branchId: string;
}

export abstract class LabResultData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<any[]>;
  abstract targetList(url: string,regId:string,tenantId:string,branchId:string):Observable<any[]>;
  abstract reportList(url: string,data: any): Observable<any>;
  abstract getById(url: string): Observable<any>;
  abstract create(url: string,data: LabResult[]): Observable<any>;
  abstract createLabMaster(url: string,data: any): Observable<any>;
  abstract updateLabMaster(url: string,data: any): Observable<any>;
  abstract update(url: string,data: LabResult): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
